import { extend } from 'sk-ui/lib/utils/util.js'

import testCaseSharedCopyForm from './metaData/testCaseSharedCopyForm'
import testCaseSharedDetail from './metaData/testCaseSharedDetail'
import testCaseSharedForm from './metaData/testCaseSharedForm'
import uploadTestCaseShare from './metaData/uploadTestCaseShare'

import { addTestCase } from '@/api/testcase'

export default {
  TestCaseSharedAdd({ commit }, params) {
    if (!params.viewController.viewMetaData.extraParams) {
      this.dispatch('OpenNotification', {
        message: '待补充用例的对象不存在，请重新点击“补充用例”重试',
        type: 'error'
      })
      return
    }
    if (!params.rowIds || params.rowIds.length === 0) {
      this.dispatch('OpenNotification', { message: '请选择至少一个用例', type: 'error' })
      return
    }
    addTestCase({
      sourceTestCaseId: params.viewController.viewMetaData.extraParams.sourceTestCaseId,
      targetTestCaseId: params.rowIds[0]
    }).then(res => {
      params.viewController.viewMetaData.extraParams.refreshParent(res.data.content)
      this.dispatch('ReturnPage')
    })
  },
  TestCaseSharedCreate({ commit }, params) {
    const props = {}
    const createForm = extend(true, {}, testCaseSharedForm)
    this.dispatch('OpenFullDialog', {
      metaData: createForm,
      props
    })
  },
  TestCaseSharedImport({ commit }, params) {
    const uploadTestCaseShareCopy = extend(true, {}, uploadTestCaseShare)
    var props = {
      params: {}
    }
    this.dispatch('OpenFullDialog', { metaData: uploadTestCaseShareCopy, props, clone: false })
  },
  TestCaseSharedCreateByCondition({ commit }, params) {
    const props = {
      params: {}
    }
    const createForm = extend(true, {}, testCaseSharedForm)

    if (params.viewController.viewMetaData.extraParams) {
      const extraParams = params.viewController.viewMetaData.extraParams
      let type = extraParams.testCaseType
      let testCaseType = ''
      if (type === 'BUSINESS') {
        testCaseType = 'BUSINESS'
      } else if (type === 'PERIPHERAL' || type === 'PERIPHERAL_COLLECT') {
        testCaseType = 'PERIPHERAL'
      } else if (type === 'SOFTWARE' || type === 'SOFTWARE_COLLECT') {
        testCaseType = 'SOFTWARE'
      }
      props.testCaseType = testCaseType
      props['view.content[$id=testCaseType].$el'] = { disabled: true }
      extraParams.recommendedId &&
        (props['view.content[$id=compatibleDTOList].$default'] = [
          { productId: extraParams.recommendedId, osTypeId: null }
        ])
    }
    this.dispatch('OpenFullDialog', {
      metaData: createForm,
      props
    })
  },
  TestCaseSharedEdit({ commit }, params) {
    const props = {
      title: '编辑共享用例',
      params: {
        id: params.rowIds[0]
      },
      'view.content[$id=testCaseCode].$el': { disabled: true },
      'view.content[$id=testCaseType].$el': { disabled: true }
    }
    const editForm = extend(true, {}, testCaseSharedForm)
    editForm.needFetchFillInfo = true
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  TestCaseSharedCopy({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        sourceTestCaseId: params.rowIds[0]
      },
      sourceTestCaseId: params.rowIds[0]
    }

    const extraParams = params.viewController.viewMetaData.extraParams
    extraParams.recommendedId && (props.extraParams.recommendedId = extraParams.recommendedId)

    const copyForm = extend(true, {}, testCaseSharedCopyForm)
    copyForm.needFetchFillInfo = true
    this.dispatch('OpenFullDialog', { metaData: copyForm, props, clone: true })
  },
  TestCaseSharedDetail({ commit }, row) {
    const props = {
      params: {
        id: row.id
      }
    }
    this.dispatch('OpenDetailDialog', {
      metaData: testCaseSharedDetail,
      props
    })
  },
  TestCaseSharedDrawerDetail({ commit }, row) {
    const props = {
      params: {
        id: row.id
      }
    }
    const testCaseSharedDetailCopy = extend(true, {}, testCaseSharedDetail)
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: testCaseSharedDetailCopy,
      props,
      drawerProps: {
        title: '【' + row.testCaseCode + '】用例详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  TestCaseSharedImportCb({ commit }, params) {}
}
